<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-card>
      <div slot="header">
        <!-- <el-button style="padding: 3px 0" type="text" @click="back">
          <i class="el-icon-arrow-left"></i>
        </el-button> -->
        <el-row style="line-height: 40px">
          <el-col :span="6">
            <div style="font-size: 16px; font-weight: bold">
              <el-button style="padding: 3px 0" type="text" @click="back">
                <i class="el-icon-arrow-left"></i>
                返回
              </el-button>
              <el-divider direction="vertical"></el-divider>
              <span> 個人修習紀錄 </span>
            </div>
          </el-col>

          <el-col :span="4" :offset="14">
            <el-button
              v-if="tabPane == 'makeUp'"
              style="float: right; margin-right: 10px"
              type="primary"
              @click="makeUpDialog"
              >新增補考</el-button
            >
          </el-col>
        </el-row>
      </div>
      <el-row style="margin-left: 20px; font-size: 16px; line-height: 10px">
        <el-col :span="5">
          <el-row>
            <span
              style="font-size: 30px; font-weight: bold; line-height: 20px"
              >{{ tableData.sgName }}</span
            >
          </el-row>
          <br />
          <br />
          <el-row>
            <span
              style="font-weight: bold; font-size: 20px; line-height: 20px"
              >{{ tableData.id }}</span
            >
            <el-tag
              v-if="tableData.suspend"
              type="danger"
              effect="plain"
              style="margin-left: 20px"
              >停止學習</el-tag
            >
            <el-tag v-else type="info" effect="plain" style="margin-left: 20px"
              >正在學習</el-tag
            >
          </el-row>
        </el-col>

        <el-col :span="19">
          <el-col :span="5">
            <div
              style="
                border-right: 2px #8f8f8f solid;
                border-left: 2px #8f8f8f solid;
                min-height: 50px;
              "
            >
              <div style="margin-left: 20px">
                <el-row>
                  <span>生活班</span>
                </el-row>
                <br />
                <br />
                <el-row>
                  <span
                    style="
                      font-size: 20px;
                      font-weight: bold;
                      line-height: 20px;
                    "
                    >{{ tableData.lifeClass }}</span
                  >
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="7">
            <div style="border-right: 2px #8f8f8f solid; min-height: 50px">
              <div style="margin-left: 20px">
                <el-row>
                  <span>當前學制班</span>
                </el-row>
                <br />
                <br />
                <el-row>
                  <span
                    style="
                      font-size: 20px;
                      font-weight: bold;
                      line-height: 20px;
                    "
                    >{{ tableData.studyYear }}</span
                  >
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="border-right: 2px #8f8f8f solid; min-height: 50px">
              <div style="margin-left: 20px">
                <el-row>
                  <span>姓名</span>
                </el-row>
                <br />
                <br />
                <el-row>
                  <span
                    style="
                      font-size: 20px;
                      font-weight: bold;
                      line-height: 20px;
                    "
                    >{{ tableData.nameL }}{{ tableData.name }}</span
                  >
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="margin-left: 20px">
              <el-row>
                <span>身份識別碼</span>
              </el-row>
              <br />
              <br />
              <el-row>
                <span
                  style="font-size: 20px; font-weight: bold; line-height: 20px"
                  >{{ tableData.identifier }}</span
                >
              </el-row>
            </div>
          </el-col>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="4" :offset="20">
          <el-button
            style="
              float: right;
              margin-right: 10px;
              margin-bottom: -20px;
              margin-top: -20px;
              font-size: 20px;
            "
            type="text"
            @click="openDialog"
            >編輯</el-button
          >
        </el-col>
      </el-row> -->
      <el-divider></el-divider>

      <el-tabs v-model="tabPane" style="margin: 20px">
        <el-tab-pane label="修習紀錄" name="education">
          <el-table :data="tableData.education" stripe style="width: 100%">
            <el-table-column
              prop="studyYear"
              label="學制班"
              header-align="center"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="written"
              label="筆試"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="debate"
              label="辯論"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="mustP"
              label="必考級別/分數"
              header-align="center"
              width="150"
              align="center"
            >
              <template slot-scope="scope">
                {{ getMust(scope.row.must) }}/{{ scope.row.mustP }}
              </template>
            </el-table-column>

            <el-table-column
              prop="eztra"
              label="額外給分"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="retention"
              label="預約加分"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="addPoints"
              label="加分考"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="gotoAddPoints(scope.row)">{{
                  scope.row.addPoints
                }}</el-button>
              </template>
            </el-table-column>

            <el-table-column
              prop="recitePoints"
              label="背書總分"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="count"
              label="背書總字數"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="fivepoint"
              label="五大論總分"
              header-align="center"
              align="center"
            >
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="補考紀錄" name="makeUp">
          <el-table :data="tableData.makeUp" stripe style="width: 100%">
            <el-table-column
              prop="studyClass.studyName"
              label="學程"
              header-align="center"
              width="150"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="recite"
              label="背書"
              header-align="center"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.recite" style="color: #7ebe50">通過</div>
              </template>
            </el-table-column>

            <el-table-column
              prop="reciteDate"
              label="背書補考日期"
              header-align="center"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                {{ getdate(scope.row.reciteDate) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="debate"
              label="辯論"
              width="100"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.debate" style="color: #7ebe50">通過</div>
              </template>
            </el-table-column>

            <el-table-column
              prop="debateDate"
              label="辯論補考日期"
              header-align="center"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                {{ getdate(scope.row.debateDate) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="memo"
              label="備註"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              fixed="right"
              label="操作"
              width="150"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="makeUpDialog(scope.row)"
                  >編輯</el-button
                >
                <el-button
                  type="danger"
                  size="small"
                  @click="makeUpEachDelete(scope.row)"
                  >刪除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="狀態變更" name="log">
          <el-table :data="tableData.log" stripe style="width: 100%">
            <el-table-column
              prop="studyPerson"
              label="法名"
              header-align="center"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="type"
              label="狀態"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="date"
              label="時間"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                {{ getdate(scope.row.date) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="user"
              label="操作者"
              header-align="center"
              width="150"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="memo"
              label="備註"
              header-align="center"
              align="center"
            >
            </el-table-column>

            <el-table-column
              fixed="right"
              label="操作"
              width="100"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="memoDialog(scope.row)"
                  >編輯</el-button
                >
              </template>
            </el-table-column>

          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-dialog title="人員資料" :visible.sync="dialogShow" width="40%">
      <personAdd
        :clickTime="dialogTime"
        :id="dialogId"
        @close="closeDialog"
      ></personAdd>
    </el-dialog>

    <el-dialog title="新增補考" :visible.sync="makeUpDialogShow" width="40%">
      <makeUpAdd
        :clickTime="dialogTime"
        :id="makeUpDialogId"
        :sp="this.$route.query.id"
        :sc="oldStudyClass"
        @close="closeDialog"
      >
      </makeUpAdd>
    </el-dialog>

    <el-dialog title="編輯備註" :visible.sync="memoDialogShow" width="40%">

        <el-input
            style="margin-bottom: 1em"
            placeholder="請輸入備註"
            v-model="memoDialogMemo"
        ></el-input>

         <el-row type="flex" justify="center">
          <el-button @click="closeMemoDialog">取消</el-button>
          <el-button
            @click="memoSave"
            type="primary"
            >儲存</el-button
          >
        </el-row>
 
    </el-dialog>
  </div>
</template>

<script>
import API from "../../api";
import Utils from "../../utils";
import makeUpAdd from "./component/makeUpAdd";
import personAdd from "./component/personAdd";
import { InformType } from "@/utils/InformType";
// eslint-disable-next-line no-undef
var moment = require("moment-timezone");

export default {
  name: "personEducation",

  components: { personAdd, makeUpAdd },
  data() {
    return {
      isLoading: false,
      tableData: [],
      tabPane: "education",

      dialogShow: false,
      dialogTime: null,
      dialogId: NaN,

      makeUpDialogShow: false,
      makeUpdialogId: NaN,

      memoDialogShow:false,
      memoDialogId:NaN,
      memoDialogMemo:"",

      id: "",
      sgName: "",
      ldate: "",
    };
  },

  created() {
    this.ldate = moment.tz.guess();
    this.query();
  },
  computed: {
    oldStudyClass() {
      return this.tableData.makeUp.map((item)=>{
        return item.studyClass.studyName;
      });
    },
  },
  methods: {
    query() {
      console.log("讀取");
      this.isLoading = true;
      API.person.personEducation(this.$route.query.id).then((res) => {
        this.tableData = res.data;
        console.log(res.data);
        this.isLoading = false;

        console.log(this.oldStudyClass);
      });
    },
    openDialog() {
      this.dialogTime = new Date();
      this.dialogShow = true;
      this.dialogId = this.$route.query.id;
    },
    closeDialog(id) {
      this.dialogShow = false;
      this.makeUpDialogShow = false;
      if (this.$route.query.id != id)
        this.$router.push({ path: `/personEducation?id=${id}` });

      this.query();
    },

    closeMemoDialog() {
      this.memoDialogShow = false;
      this.memoDialogMemo = "";
    },

    back() {
      this.$router.push({ name: "學員資料管理" });
    },

    gotoAddPoints(row) {
      this.$router.push({
        path: `/addPoints?id=${row.studyYearId}&pid=${this.$route.query.id}&to=personEducation`,
      });
    },

    getMust(row) {
      if (Utils.Check.isNull(row)) return "";

      if (row.seq == -1) return "未通過";
      else return "級別" + (row.seq + 1);
    },

    getdate(date) {
      if (Utils.Check.isNull(date)) return "";
      var a = moment.tz(date, this.ldate);
      return a.format("YYYY-MM-DD");
    },

    makeUpDialog(row) {
      this.dialogTime = new Date();
      this.makeUpDialogId = row ? row.id : NaN;
      this.makeUpDialogShow = true;
    },

    memoDialog(row){
      this.memoDialogShow =true;
      this.memoDialogId=row.id;
      this.memoDialogMemo =JSON.parse(JSON.stringify(row.memo));
    },

    memoSave(){
      this.isLoading = true;
      console.log(this.memoDialogId,this.memoDialogMemo);
      API.person.suspendMemo(this.memoDialogId,{memo:this.memoDialogMemo}).then(() => {
        Utils.Message.send("更新備註成功!", InformType.SUCCESS);
        this.isLoading = false;
        this.closeMemoDialog();
        this.query();
      }).catch(()=>{
        this.isLoading = false;
      });
    },

    makeUpEachDelete(row) {
      this.isLoading = true;
      if (row.id) {
        API.person.makeUpEachDelete(row.id).then(() => {
          Utils.Message.send("刪除補考資料成功!", InformType.SUCCESS);
          this.isLoading = false;
          this.query();
        }).catch(()=>{
          this.isLoading = false;
        });
      }
    },
  },
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
</style>